import React from 'react';
import { Pinterest, Facebook, Twitter, YouTube, LinkedIn, Apple, Instagram } from '@material-ui/icons';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import styles from '../../../../constants/styles';
import { TikTokIcon } from './tiktokIcon';
var useStyles = makeStyles(function () {
    return createStyles({
        bar: {
            display: 'flex',
            justifyContent: 'center',
            columnGap: '20px',
            paddingTop: '10px',
            flexWrap: 'wrap'
        },
        icon: {
            color: styles.color.socialIcons,
            minWidth: 10,
        }
    });
});
export var SocialMediaIcons = function (_a) {
    var socialMediaButtons = _a.socialMediaButtons;
    var iconBarStyles = useStyles();
    return (React.createElement("div", { className: iconBarStyles.bar },
        socialMediaButtons.facebook &&
            React.createElement(Link, { href: socialMediaButtons.facebook, target: "_blank", "data-testid": 'lib-fb-icon' },
                React.createElement(Facebook, { fontSize: "large", className: iconBarStyles.icon })),
        socialMediaButtons.twitter &&
            React.createElement(Link, { href: socialMediaButtons.twitter, target: "_blank", "data-testid": 'lib-tw-icon' },
                React.createElement(Twitter, { fontSize: "large", className: iconBarStyles.icon })),
        socialMediaButtons.pinterest &&
            React.createElement(Link, { href: socialMediaButtons.pinterest, target: "_blank", "data-testid": 'lib-pi-icon' },
                React.createElement(Pinterest, { fontSize: "large", className: iconBarStyles.icon })),
        socialMediaButtons.youtube &&
            React.createElement(Link, { href: socialMediaButtons.youtube, target: "_blank", "data-testid": 'lib-yt-icon' },
                React.createElement(YouTube, { fontSize: "large", className: iconBarStyles.icon })),
        socialMediaButtons.linkedin &&
            React.createElement(Link, { href: socialMediaButtons.linkedin, target: "_blank", "data-testid": 'lib-li-icon' },
                React.createElement(LinkedIn, { fontSize: "large", className: iconBarStyles.icon })),
        socialMediaButtons.instagram &&
            React.createElement(Link, { href: socialMediaButtons.instagram, target: "_blank", "data-testid": 'lib-ig-icon' },
                React.createElement(Instagram, { fontSize: "large", className: iconBarStyles.icon })),
        socialMediaButtons.tiktok &&
            React.createElement(Link, { href: socialMediaButtons.tiktok, target: "_blank", "data-testid": 'lib-tt-icon' },
                React.createElement(TikTokIcon, { color: styles.color.socialIcons })),
        socialMediaButtons.apple &&
            React.createElement(Link, { href: socialMediaButtons.apple, target: "_blank", "data-testid": 'lib-apple-icon' },
                React.createElement(Apple, { fontSize: "large", className: iconBarStyles.icon }))));
};
